// Profile Types
export const SET_PROFILE_ERRORS = "SET_PROFILE_ERRORS";
export const RESET_PROFILE_ERRORS = "RESET_PROFILE_ERRORS";
export const UPDATE_USER = "UPDATE_USER";
